export const PERFIS_PERMISSOES = {
  admin: {
    financeiro_ver: true, financeiro_exportar: true,
    clientes_editar: true, clientes_excluir: true,
    obras_editar: true, obras_excluir: true, obras_gerenciar: true, obras_apenas_cronograma: false,
    servicos_editar: true, servicos_excluir: true,
    pagamentos_editar: true, pagamentos_excluir: true,
    cadastros_editar: true, configuracoes_editar: true,
    usuarios_gerenciar: true,
    projetos_cad_ver: true, projetos_cad_anexar: true, projetos_cad_deletar: true,
    projetos_doc_ver: true, projetos_doc_anexar: true, projetos_doc_deletar: true,
  },
  gerente: {
    financeiro_ver: true, financeiro_exportar: true,
    clientes_editar: true, clientes_excluir: true,
    obras_editar: true, obras_excluir: true, obras_gerenciar: true, obras_apenas_cronograma: false,
    servicos_editar: true, servicos_excluir: true,
    pagamentos_editar: true, pagamentos_excluir: true,
    cadastros_editar: true, configuracoes_editar: true,
    usuarios_gerenciar: false,
    projetos_cad_ver: true, projetos_cad_anexar: true, projetos_cad_deletar: true,
    projetos_doc_ver: true, projetos_doc_anexar: true, projetos_doc_deletar: true,
  },
  operador: {
    financeiro_ver: false, financeiro_exportar: false,
    clientes_editar: true, clientes_excluir: false,
    obras_editar: true, obras_excluir: false, obras_gerenciar: true, obras_apenas_cronograma: false,
    servicos_editar: true, servicos_excluir: true,
    pagamentos_editar: true, pagamentos_excluir: true,
    cadastros_editar: false, configuracoes_editar: false,
    usuarios_gerenciar: false,
    projetos_cad_ver: true, projetos_cad_anexar: true, projetos_cad_deletar: false,
    projetos_doc_ver: true, projetos_doc_anexar: true, projetos_doc_deletar: false,
  },
};

export const GRUPOS_PERMISSOES = [
  {
    grupo: 'Financeiro',
    itens: [
      { chave: 'financeiro_ver', label: 'Ver tela financeiro' },
      { chave: 'financeiro_exportar', label: 'Exportar relatórios' },
    ],
  },
  {
    grupo: 'Clientes',
    itens: [
      { chave: 'clientes_editar', label: 'Criar e editar' },
      { chave: 'clientes_excluir', label: 'Excluir' },
    ],
  },
  {
    grupo: 'Obras',
    itens: [
      { chave: 'obras_editar', label: 'Criar e editar', exclusivoCom: ['obras_apenas_cronograma'] },
      { chave: 'obras_excluir', label: 'Excluir', exclusivoCom: ['obras_apenas_cronograma'] },
      { chave: 'obras_gerenciar', label: 'Iniciar / Concluir / Pausar', exclusivoCom: ['obras_apenas_cronograma'] },
      { chave: 'obras_apenas_cronograma', label: 'Apenas visualizar cronograma', exclusivoCom: ['obras_editar', 'obras_excluir', 'obras_gerenciar'] },
    ],
  },
  {
    grupo: 'Serviços e Materiais',
    itens: [
      { chave: 'servicos_editar', label: 'Criar e editar' },
      { chave: 'servicos_excluir', label: 'Excluir' },
    ],
  },
  {
    grupo: 'Pagamentos',
    itens: [
      { chave: 'pagamentos_editar', label: 'Criar e editar' },
      { chave: 'pagamentos_excluir', label: 'Excluir' },
    ],
  },
  {
    grupo: 'Cadastros (Serviços, Formas de Pagamento)',
    itens: [
      { chave: 'cadastros_editar', label: 'Criar / Editar / Excluir' },
    ],
  },
  {
    grupo: 'Configurações',
    itens: [
      { chave: 'configuracoes_editar', label: 'Acessar e editar SINAPI' },
    ],
  },
  {
    grupo: 'Usuários',
    itens: [
      { chave: 'usuarios_gerenciar', label: 'Gerenciar usuários' },
    ],
  },
  {
    grupo: 'Projetos - CAD (DWG/DXF)',
    itens: [
      { chave: 'projetos_cad_ver', label: 'Visualizar' },
      { chave: 'projetos_cad_anexar', label: 'Anexar', dependeDe: 'projetos_cad_ver' },
      { chave: 'projetos_cad_deletar', label: 'Excluir', dependeDe: 'projetos_cad_ver' },
    ],
  },
  {
    grupo: 'Projetos - Documentos (PDF/PNG/JPG)',
    itens: [
      { chave: 'projetos_doc_ver', label: 'Visualizar' },
      { chave: 'projetos_doc_anexar', label: 'Anexar', dependeDe: 'projetos_doc_ver' },
      { chave: 'projetos_doc_deletar', label: 'Excluir', dependeDe: 'projetos_doc_ver' },
    ],
  },
];

export function temPermissao(chave) {
  try {
    const usuario = JSON.parse(sessionStorage.getItem('usuario'));
    if (!usuario) return false;
    if (usuario.role === 'admin') return true;
    return usuario.permissoes?.[chave] === true;
  } catch {
    return false;
  }
}

// Para permissões que são restrições (ex: obras_apenas_cronograma):
// admin nunca é restringido, independente do valor salvo.
export function temRestricao(chave) {
  try {
    const usuario = JSON.parse(sessionStorage.getItem('usuario'));
    if (!usuario) return false;
    if (usuario.role === 'admin') return false;
    return usuario.permissoes?.[chave] === true;
  } catch {
    return false;
  }
}
